//ClientSite.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import Server from "components/Server";
import Common from "components/Common";
import BottomBar from "components/BottomBar";
import createAbsoluteGrid from "AbsoluteGrid/AbsoluteGrid";
import GridItem from "components/GridItem";
import FullPageLoader from "components/FullPageLoader";
import Cache from "Cache";
import SentimentDissatisfied from "@material-ui/icons/SentimentDissatisfied";
import { orderBy } from "lodash";
import Moon from "../packages/Moon";
import WebWorkers from "WebWorkers/WebWorkers";
import UpdateCurrentPage from "WebWorkers/Workers/UpdateCurrentPage";
import CreateFlatItemsPage from "WebWorkers/Workers/CreateFlatItemsPage";

const styles = {
	root: {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		backgroundColor: "rgba(250, 250, 250, 1)",
		display: "flex",
		flexDirection: "column",
		flexWrap: "nowrap"
	},
	context: {
		position: "relative",
		zIndex: 1,
		padding: "3% 6%",
		width: "100%",
		overflow: "hidden",
		transition: "opacity 300ms ease 0s",
		boxSizing: "border-box"
	},
	bottomBar: {
		height: "50px",
		minHeight: "50px",
		width: "100%",
		maxWidth: "100%",
		backgroundColor: "white",
		boxShadow: "0px 0px 15px rgba(0,0,0,0.2)",
		position: "relative",
		zIndex: 2,
		transition: "height 300ms ease 0s",
		overflow: "hidden"
	},
	bottomBarSelectedItemMode: {
		height: "140px"
	},
	noResults: {
		width: "100%",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		fontSize: "2rem",
		color: "#777",
		fontWeight: 500
	},
	gridBox: {
		position: "relative",
		width: "100%",
		height: "100%",
		overflow: "hidden auto"
	},
	gridBoxInnerWidth: {
		position: "relative",
		zIndex: "1",
		width: "100%",
		overflowX: "hidden",
		boxSizing: "border-box"
	},
	flatItemsPage: {
		position: "absolute",
		width: "100%",
		borderBottom: "2px solid rgb(63, 81, 181)",
		height: "10px",
		textAlign: "right",
		opacity: "0.8",
		zIndex: "2",
		cursor: "default"
	},
	flatItemsPageText: {
		fontSize: "14px",
		fontWeight: "400",
		marginRight: "0.5%",
		borderRadius: "50px",
		backgroundColor: "rgb(63, 81, 181)",
		padding: "0px 10px",
		color: "white"
	}
};

const classes = StyleSheet.create({
	noResultsIcon: {
		fontSize: "5rem",
		color: "#777",
		marginBottom: "1.5%"
	}
});

class ClientSite extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			selectedItems: [],
			isCtrlKeyDown: false,
			noResults: false,
			currentPage: 1,
			maxPage: 1,
			pageLoading: true,
			minSort: 0,
			maxSort: 9999,
			searchValue: Moon.use(null),
			products: Moon.use([]),
			itemWidth: 300,
			itemHeight: 400,
			itemsPerRow: Moon.use(),
			gridZoom: "100%",
			gridZoomNumber: 1,
			sliderZoomValue: Moon.use(),
			gridBoxInnerWidth: "100%",
			flatItems: Moon.use(),
			imageMode: Moon.use(),
			flatItemsPages: [],
			rtlGrid: Moon.use(),
			lastVisitedItem: Moon.use(),
			gridForceResize: Moon.use(false),
			forceRenderGrid: false,
			scrollTop: 0,
			containerWidth: 0,
			containerHeight: 0,
			gridBoxContainer: null,
			gridLayoutWidth: 0
		};
        this.platform = null;
		this.serverRequests = [];
		this.getPagesTimeout = null;
		this.updateCurrentPageTimeout = null;
		this.gridContainer = null;
		this.gridContainerRect = null;
		this.gridContainerTopPx = null;
		this.gridContainerBottomPx = null;
		this.gridContainerDragging = false;
		this.scrolling = null;
		this.firstTimeSource = null;
		this.productsPages = [];
		this.currentLoadPage = 1;
		this.productsKeyCounter = 0;
		this.from = -1;
		this.to = -1;
		this.setTimeout = null;
		this.hiddenElement = null;
		this.isInsideGrid = null;
		this.lastFrom = null;
		this.productsPerPage = null;
		this.totalPagesToLoad = 3;
		this.totalPages = 1;
		this.loadPagesInterval = null;
		this.flatItemsPagesNumbers = [];
		this.scrollToAnimationTimeout = null;
		this.updateScrollTopTimeout = null;
		this.flatItemsScrollToInProgress = false;
        this.shopifyEmptyPagesCounter = 0; 
        this.maxAllowShopifyEmptyPages = 5;
        this.shopifyFirstPageWasLoaded  = false;
        this.shopifyNumOfPages = 0;
        this.lastShopifyCursor = 0;

		this.onMove = this.onMove.bind(this);
		this.onDragEnd = this.onDragEnd.bind(this);
		this.getPageDone = this.getPageDone.bind(this);
		this.changePage = this.changePage.bind(this);
		this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
		this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
		this.handleIsInsideGrid = this.handleIsInsideGrid.bind(this);
		this.handleMouseMoveForScroll = this.handleMouseMoveForScroll.bind(
			this
		);
		this.createGridContainerRef = this.createGridContainerRef.bind(this);
		this.clearSelectedItems = this.clearSelectedItems.bind(this);
		this.setProducts = this.setProducts.bind(this);
		this.setGridZoom = this.setGridZoom.bind(this);
		this.gridForceResizeDone = this.gridForceResizeDone.bind(this);
		this.forceRenderGridDone = this.forceRenderGridDone.bind(this);
		this.createFlatItemsPage = this.createFlatItemsPage.bind(this);
		this.gridBoxOnScroll = this.gridBoxOnScroll.bind(this);
		this.createFlatItemsPageDone = this.createFlatItemsPageDone.bind(this);
		this.onLayoutWidth = this.onLayoutWidth.bind(this);
		this.updateCurrentPageDone = this.updateCurrentPageDone.bind(this);
		this.flatItemsScrollTo = this.flatItemsScrollTo.bind(this);
		this.flatItemsScrollToDone = this.flatItemsScrollToDone.bind(this);
        this.getShopifyPageDone = this.getShopifyPageDone.bind(this);

		// Web Workers
		WebWorkers.add(
			"UpdateCurrentPage",
			UpdateCurrentPage,
			this.updateCurrentPageDone
		);

		WebWorkers.add(
			"CreateFlatItemsPage",
			CreateFlatItemsPage,
			this.createFlatItemsPageDone
		);

		ClientSite.isInsideGrid = () => {
			return this.isInsideGrid;
		};
		ClientSite.onMove = (from, to, hideFrom = false) => {
			this.onMove(from, to, hideFrom);
		};
		ClientSite.clearHiddenElement = () => {
			this.clearHiddenElement();
		};
		ClientSite.getProducts = () => {
			return this.state.products;
		};

		ClientSite.onResize = () => {
			this.onResize();
			this.setState({ gridForceResize: true });
		};
	}

	componentWillMount() {
		Moon.addStar(this);
	}

	componentDidMount() {
		FullPageLoader.open(
			"Loading category - " + this.props.categoryName,
			"Please wait"
		);
        this.platform = Cache.settings.platform;
		this.getPageByPlatform();
		document.addEventListener("keydown", this.handleOnKeyDown);
		document.addEventListener("keyup", this.handleOnKeyUp);
		document.addEventListener("mousedown", this.handleOnDragStartEvents);
		document.addEventListener("touchstart", this.handleOnDragStartEvents);
		document.addEventListener("mouseup", this.handleOnDragStopEvents);
		document.addEventListener("touchend", this.handleOnDragStopEvents);
		document.addEventListener("touchcancel", this.handleOnDragStopEvents);
	}

	componentWillUnmount() {
		this.clearTimeoutsAndIntervals();
		this.serverRequests.forEach(req => {
			req.abort();
		});
		this.serverRequests = [];
		document.removeEventListener("keydown", this.handleOnKeyDown);
		document.removeEventListener("keyup", this.handleOnKeyUp);
		document.removeEventListener("mousedown", this.handleOnDragStartEvents);
		document.removeEventListener(
			"touchstart",
			this.handleOnDragStartEvents
		);
		document.removeEventListener("mouseup", this.handleOnDragStopEvents);
		document.removeEventListener("touchend", this.handleOnDragStopEvents);
		document.removeEventListener(
			"touchcancel",
			this.handleOnDragStopEvents
		);
		window.removeEventListener("resize", this.onResize);
		if (this.gridContainer) {
			this.gridContainer.removeEventListener(
				"scroll",
				this.gridBoxOnScroll,
				this.getSupportsPassive() ? { passive: true } : false
			);
		}
		WebWorkers.terminate();
	}

	clearTimeoutsAndIntervals() {
		// Timeouts
		clearTimeout(this.getPagesTimeout);
		clearTimeout(this.scrollToAnimationTimeout);
		clearTimeout(this.updateCurrentPageTimeout);
		clearTimeout(this.setTimeout);
		// Intervals
		clearInterval(this.loadPagesInterval);
	}

	initGridZoom() {
		window.addEventListener("resize", this.onResize);
		this.onResize();
	}

	onResize = () => {
		if (this.isSortingTourShouldOpen()) return;

		if (window.requestAnimationFrame) {
			window.requestAnimationFrame(this.setGridZoom);
		} else {
			setTimeout(this.setGridZoom, 66);
		}
	};

	setGridZoom() {
		let clientSite = document.getElementById("ClientSite");
		if (clientSite == null) return;
		let width = clientSite.clientWidth;
		let sliderZoomValue = this.state.sliderZoomValue / 100;
		width = width * sliderZoomValue;
		let rowWidth = (this.state.itemsPerRow + 1) * this.state.itemWidth;
		let gridZoom = "100%";
		gridZoom = 100 - ((rowWidth - width) / rowWidth) * 100;
		let gridZoomNumber = gridZoom / 100;

		this.setState({
			gridBoxInnerWidth: sliderZoomValue == 1 ? "100%" : width + "px",
			gridZoom: gridZoom + "%",
			gridZoomNumber: gridZoomNumber
		});
	}

	forceRenderGridDone() {
		this.setState({ forceRenderGrid: false });
	}

	gridForceResizeDone() {
		this.setState({ gridForceResize: false });
	}

	onLayoutWidth(width) {
		this.setState({ gridLayoutWidth: width });
	}

	isSortingTourShouldOpen() {
		let sortingTour = Cache.getCookie("sortingTour");
		return sortingTour == null || sortingTour != "true";
	}

	openSortingTour() {
		if (this.isSortingTourShouldOpen()) this.props.openTour("sorting");
	}

	getSupportsPassive() {
		var supportsPassive = false;
		try {
			var opts = Object.defineProperty({}, "passive", {
				get: function() {
					supportsPassive = true;
				}
			});
			window.addEventListener("testPassive", null, opts);
			window.removeEventListener("testPassive", null, opts);
		} catch (e) {}

		return supportsPassive;
	}

	createGridContainerRef = gridContainer => {
		if (gridContainer) {
			this.gridContainer = gridContainer;
			this.setState({ gridBoxContainer: this.gridContainer });
			this.gridContainer.addEventListener(
				"scroll",
				this.gridBoxOnScroll,
				this.getSupportsPassive() ? { passive: true } : false
			);
		}
	};

	handleOnDragStartEvents = e => {
		if (this.isGridItem(e.target) === false) return;
		this.gridContainerDragging = true;
		document.addEventListener("mousemove", this.handleIsInsideGrid);
		document.addEventListener("touchmove", this.handleIsInsideGrid);
		document.addEventListener("mousemove", this.handleMouseMoveForScroll);
		document.addEventListener("touchmove", this.handleMouseMoveForScroll);
	};

	isGridItem(elem) {
		while (elem != null && elem.parentNode) {
			if (elem.getAttribute("data-key")) {
				return true;
			}
			elem = elem.parentNode;
		}
		return false;
	}

	handleOnDragStopEvents = e => {
		this.gridContainerDragging = false;
		document.removeEventListener("mousemove", this.handleIsInsideGrid);
		document.removeEventListener("touchmove", this.handleIsInsideGrid);
		document.removeEventListener(
			"mousemove",
			this.handleMouseMoveForScroll
		);
		document.removeEventListener(
			"touchmove",
			this.handleMouseMoveForScroll
		);
	};

	handleIsInsideGrid = e => {
		if (
			this.gridContainer == null ||
			typeof this.gridContainer.getBoundingClientRect != "function"
		)
			return;
		let rect = this.gridContainer.getBoundingClientRect();
		const isTouch = e.touches && e.touches.length;
		const pageX = isTouch ? e.touches[0].pageX : e.pageX;
		const pageY = isTouch ? e.touches[0].pageY : e.pageY;
		let calcPageX = pageX * this.state.gridZoomNumber;
		let calcpageY = pageY * this.state.gridZoomNumber;
		if (
			calcPageX >= rect.left * this.state.gridZoomNumber &&
			calcPageX <= rect.right * this.state.gridZoomNumber &&
			calcpageY >= rect.top * this.state.gridZoomNumber &&
			calcpageY <= rect.bottom * this.state.gridZoomNumber
		)
			this.isInsideGrid = true;
		else {
			this.undoFirstTimeSource();
			this.isInsideGrid = false;
		}
	};

	handleMouseMoveForScroll = e => {
		if (this.gridContainer == null) return;
		let rect = this.gridContainer.getBoundingClientRect();
		this.gridContainerTopPx = rect.height * 0.07;
		this.gridContainerBottomPx = rect.height - this.gridContainerTopPx;
		const isTouch = e.touches && e.touches.length;
		const pageY = isTouch ? e.touches[0].pageY : e.pageY;
		const y = pageY - rect.y;
		if (
			y <= this.gridContainerTopPx &&
			this.scrolling == null &&
			this.gridContainerDragging == true
		) {
			this.scrolling = 10 * -1;
			this.autoScrollTo(-1);
		} else if (
			y >= this.gridContainerBottomPx &&
			this.scrolling == null &&
			this.gridContainerDragging == true
		) {
			this.scrolling = 10;
			this.autoScrollTo(1);
		} else if (
			this.scrolling != null &&
			this.gridContainerDragging == true &&
			y > this.gridContainerTopPx &&
			y < this.gridContainerBottomPx
		) {
			this.scrolling = null;
		}
	};

	autoScrollTo(nav) {
		if (this.gridContainerDragging == false) {
			this.scrolling = null;
			return;
		}
		if (this.scrolling == null) return;
		setTimeout(() => {
			if (nav < 0 && this.scrolling > 0)
				this.scrolling = this.scrolling * nav;
			this.scrolling = this.scrolling * 1.02;
			let prevScroll = this.gridContainer.scrollTop;
			this.gridContainer.scrollTop =
				this.gridContainer.scrollTop + this.scrolling;
			if (prevScroll == this.gridContainer.scrollTop) {
				this.scrolling = null;
				return;
			}
			return this.autoScrollTo(nav);
		}, 25);
	}

	flatItemsScrollTo(pageNumber) {
		if (this.gridContainer == null) return;
		this.flatItemsScrollToInProgress = true;
		Common.scrollTo(
			this.gridContainer,
			Math.max(
				0,
				this.flatItemsPagesNumbers[pageNumber] -
					25 * this.state.gridZoomNumber
			),
			1000,
			this.flatItemsScrollToDone
		);
	}

	flatItemsScrollToDone() {
		this.flatItemsScrollToInProgress = false;
	}

	gridBoxOnScroll() {
		let scrollTop = this.gridContainer.scrollTop;
		this.updateCurrentPage(scrollTop);
	}

	updateCurrentPage(scrollTop) {
		if (this.shouldUpdateCurrentPage()) {
			clearTimeout(this.updateCurrentPageTimeout);
			this.updateCurrentPageTimeout = setTimeout(() => {
				WebWorkers.execute("UpdateCurrentPage", [
					this.state.gridLayoutWidth,
					this.getGridLayoutTop(),
					this.state.itemWidth,
					this.state.itemHeight,
					-1,
					this.state.itemsPerRow,
					this.state.gridZoomNumber,
					this.productsPerPage,
					this.totalPages,
					scrollTop
				]);
			}, 100);
		}
	}

	updateCurrentPageDone(res) {
		let currentPage = res;
		if (currentPage != this.state.currentPage)
			this.setState({ currentPage: currentPage });
	}

	isScrolledIntoView(el) {
		console.log(el.style);
		let rect = el.getBoundingClientRect();
		let elemTop = rect.top;
		let elemBottom = rect.bottom;
		if (elemTop == 0 && elemBottom == 0) return false;
		// Only completely visible elements return true:
		//var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
		// Partially visible elements return true:
		let isVisible =
			elemTop < this.gridContainer.clientHeight && elemBottom >= 0;
		return isVisible;
	}

	handleOnKeyDown = event => {
		if (event.key === "Control" && this.state.isCtrlKeyDown === false) {
			this.setState({ isCtrlKeyDown: true });
		}
	};

	handleOnKeyUp = event => {
		if (event.key === "Control" && this.state.isCtrlKeyDown === true) {
			this.setState({ isCtrlKeyDown: false });
		}
	};

	initClientSite() {}

	changePage(page) {
		if (this.state.flatItems) {
			this.flatItemsScrollTo(page - 1);
		} else {
			let minSort = (page - 1) * this.productsPerPage;
			this.setState({
				currentPage: page,
				minSort: minSort,
				maxSort: minSort + this.productsPerPage
			});
		}
	}

    getPageByPlatform() {
        if (this.platform != "shopify")
            this.getFirstPage();
        else
            this.getShopifyPages(0);
    }

    getShopifyPages(cursor) {
            console.log(cursor);
            this.lastShopifyCursor = cursor;
            let serverRequest = Server.post(
			"/webpage/get_shopify",
			{
				category_id: this.props.categoryId,
				category_type: this.props.categoryType,
				page: 1,
				total_pages: 1,
                cursor: cursor
			},
			this.getShopifyPageDone
		);
		this.serverRequests.push(serverRequest);
    }

    getShopifyPageDone(res) {
        console.log(res);
        if (this.serverRequests.length == 0) return;
        const pages = res.data.productsDetails;
        const filteredPages = pages.filter(page => page.products.length > 0);
        this.shopifyNumOfPages += filteredPages.length;

        this.loadShopifyPages(filteredPages, this.shopifyNumOfPages);

        if (!this.shopifyFirstPageWasLoaded && this.shopifyNumOfPages > 0) {
            this.handleFirstPageLoadFromShopify(filteredPages[0], this.shopifyNumOfPages);
            this.shopifyFirstPageWasLoaded = true;
        }

        const lastPage = pages[pages.length - 1];
        if (!lastPage.last_page && this.validateShopifyPagination(pages, lastPage.cursor))
            this.getShopifyPages(lastPage.cursor)
        else
            this.setState({ pageLoading: false });
    }

    validateShopifyPagination(pages, cursor) {
        if (cursor == this.lastShopifyCursor)
            return false;
        const allEmpty = pages.every(page => page.products.length == 0);
        if (allEmpty)
            this.shopifyEmptyPagesCounter++;
        else
            this.shopifyEmptyPagesCounter = 0;

        if (this.shopifyEmptyPagesCounter >= this.maxAllowShopifyEmptyPages)
            return false;
        return true;
    }

    loadShopifyPages(pages, numOfPages) {
        const products = [];
        pages.forEach(page => {
            this.productsPages[page.page] = page;
            page.products.forEach(p => {
                p["gridName"] = "clientsite";
                p["key"] = this.productsKeyCounter;
                p["sort"] = this.productsKeyCounter;
                p["filtered"] = 0;
                p["style"] = {};
                p["selected"] = false;
                p["search"] = this.fillItemSearch(p);
                p["sortby_price"] =
                    p["special_price"] != -1 ? p["special_price"] : p["price"];
                p["discount_percentages"] = this.getItemDiscountPercentages(p);
                this.productsKeyCounter = this.productsKeyCounter + 1;
                products.push(p);
            });
        });

		this.setState({
			products: this.state.products.concat(products),
			open: true,
			maxPage: numOfPages
		});
    }

    handleFirstPageLoadFromShopify(page, numberOfPages) {
        this.totalPages = numberOfPages;
		let products = page.products;
		FullPageLoader.close();
		if (products.length == 0) {
			this.setState({
				products: [],
				open: false,
				noResults: true,
				maxPage: 0
			});
			return;
		}
		this.productsPerPage = products.length;
		this.setState({
			showSearch: true,
			maxSort: this.productsPerPage
		});

		this.initGridZoom();

		setTimeout(() => {
			this.openSortingTour();
		}, 1000);
    }

	getFirstPage() {
		let serverRequest = Server.post(
			"/webpage/get",
			{
				category_id: this.props.categoryId,
				category_type: this.props.categoryType,
				page: 1,
				total_pages: 1
			},
			this.getPageDone
		);
		this.serverRequests.push(serverRequest);

        this.getPagesTimeout = setTimeout(() => {
            this.getPages(2, this.totalPagesToLoad, false);
        }, 100);
	}

	getPages(page, totalPages, continueToLoad = true) {
		let serverRequest = Server.post(
			"/webpage/get",
			{
				category_id: this.props.categoryId,
				category_type: this.props.categoryType,
				page: page,
				total_pages: totalPages
			},
			this.getPageDone
		);
		this.serverRequests.push(serverRequest);
		let nextPage = this.totalPagesToLoad > 1 ? page + totalPages : page + 1;
		if (continueToLoad && nextPage <= this.totalPages) {
			this.getPagesTimeout = setTimeout(() => {
				this.getPages(nextPage, this.totalPagesToLoad);
			}, 100);
		}
	}

	getPageDone(res) {
		if (this.serverRequests.length == 0) return;
		let productsPages = res.data.productsDetails;
		console.log(productsPages);
		productsPages.forEach(productsPage => {
			this.productsPages[productsPage.page] = productsPage;
			if (productsPage.page == 1) {
				this.handleFirstPageLoad(productsPage);
			}
		});
	}

	handleFirstPageLoad(productsPage) {
		this.totalPages = productsPage.total_pages;
		let products = productsPage.products;
		FullPageLoader.close();
		if (products.length == 0) {
			this.setState({
				products: [],
				open: false,
				noResults: true,
				maxPage: 0
			});
			return;
		}
		this.productsPerPage = products.length;
		this.loadPages();
		this.setState({
			showSearch: true,
			maxSort: this.productsPerPage
		});

        if (productsPage.total_pages > 1) {
            this.currentLoadPage = 2;
            this.loadPagesInterval = setInterval(() => {
                this.loadPages();
            }, 100);
            if (2 + this.totalPagesToLoad <= productsPage.total_pages) {
                this.getPages(2 + this.totalPagesToLoad, this.totalPagesToLoad);
            }
        }

		this.initGridZoom();

		setTimeout(() => {
			this.openSortingTour();
		}, 1000);
	}

	fillItemSearch(item) {
		let additionalAttributes = item.additional_attributes;
        let values = Object.values(additionalAttributes);
		let search = item.name != null ? item.name.toLowerCase() : "";
		values.forEach(val => {
			if (val != null) search += " " + val.toLowerCase();
		});

		return search;
	}

	loadPages() {
		if (this.productsPages[this.currentLoadPage] == null) return;
		let productsPage = this.productsPages[this.currentLoadPage];
		this.currentLoadPage = this.currentLoadPage + 1;
		let products = productsPage.products;
		products.forEach(p => {
			p["gridName"] = "clientsite";
			p["key"] = this.productsKeyCounter;
			p["sort"] = this.productsKeyCounter;
			p["filtered"] = 0;
			p["style"] = {};
			p["selected"] = false;
			p["search"] = this.fillItemSearch(p);
			p["sortby_price"] =
				p["special_price"] != -1 ? p["special_price"] : p["price"];
			p["discount_percentages"] = this.getItemDiscountPercentages(p);
			this.productsKeyCounter = this.productsKeyCounter + 1;
		});

		this.setState({
			products: this.state.products.concat(products),
			open: true,
			maxPage: productsPage.page
		});
		if (productsPage.page == this.totalPages) {
			clearInterval(this.loadPagesInterval);
			this.setState({ pageLoading: false });
		}
	}

	getItemDiscountPercentages(item) {
		if (item["special_price"] > 0 && item["price"] > 0) {
			let specialPrice = parseFloat(item["special_price"]);
			let price = parseFloat(item["price"]);

			if (specialPrice > price) return null;
			return ((1 / (price / (price - specialPrice))) * 100).toFixed(1);
		}
		return null;
	}

	isCtrlKeyDown() {
		return this.state.isCtrlKeyDown;
	}

	setLastVisitedItem(item) {
		if (this.isSortingTourShouldOpen()) return;
		this.setState({ lastVisitedItem: item });
	}

	AbsoluteGrid = createAbsoluteGrid(
		GridItem,
		{
			selectedItemOnClick: this.selectedItemOnClick.bind(this),
			isCtrlKeyDown: this.isCtrlKeyDown.bind(this),
			setLastVisitedItem: this.setLastVisitedItem.bind(this)
		},
		false
	);

	renderGrid() {
		const flatItems = this.state.flatItems == true;
		return (
			<div
				id="GridBox"
				style={styles.gridBox}
				ref={this.createGridContainerRef}
			>
				<div
					style={{
						...styles.gridBoxInnerWidth,
						...{ width: this.state.gridBoxInnerWidth }
					}}
				>
					<div
						id="GridBoxInner"
						style={{
							...styles.context,
							...{ zoom: this.state.gridZoom }
						}}
					>
						<this.AbsoluteGrid
							items={this.state.products}
							onMove={this.onMove}
							onDragEnd={this.onDragEnd}
							dragEnabled={true}
							zoom={1}
							containerZoom={this.state.gridZoomNumber}
							responsive={false}
							verticalMargin={-1}
							itemWidth={this.state.itemWidth}
							itemHeight={this.state.itemHeight}
							animation={"transform 200ms ease 0s"}
							rtl={JSON.parse(this.state.rtlGrid)}
							minSort={flatItems ? 0 : this.state.minSort}
							maxSort={flatItems ? 9999 : this.state.maxSort}
							forceResize={this.state.gridForceResize}
							forceResizeDone={this.gridForceResizeDone}
							itemsPerRow={this.state.itemsPerRow}
							gridBoxContainer={this.state.gridBoxContainer}
							onLayoutWidth={this.onLayoutWidth}
							isCtrlKeyDown={this.state.isCtrlKeyDown}
							imageMode={this.state.imageMode}
						/>
					</div>
				</div>
				{this.renderFlatItemsPages()}
			</div>
		);
	}

	renderFlatItemsPages() {
		if (
			this.state.flatItemsPages == null ||
			this.state.flatItemsPages.length == 0
		)
			return null;
		return (
			<div style={styles.flatItemsPagesBox}>
				{this.state.flatItemsPages}
			</div>
		);
	}

	selectedItemOnClick(item) {
		let updatedProducts = [...this.state.products];
		const index = updatedProducts.findIndex(
			innerItem => innerItem.key === item.key
		);
		updatedProducts[index] = { ...item, selected: !item.selected };
		let selectedItems = updatedProducts.filter(x => x.selected == true);
		selectedItems = orderBy(selectedItems, "sort", "asc");
		this.setState({
			products: updatedProducts,
			selectedItems: selectedItems
		});
	}

	clearSelectedItems() {
		let updatedProducts = this.state.products.map(item => {
			let updatedItem = Object.assign({}, item);
			updatedItem.selected = false;
			return updatedItem;
		});

		this.setState({
			products: updatedProducts,
			selectedItems: []
		});
	}

	setProducts(products) {
		this.setState({ products: products });
	}

	onMove(from, to, hideSource = false) {
		if (
			(this.from == from && this.to == to) ||
			from == to ||
			this.isInsideGrid == false
		)
			return;
		this.from = from;
		this.to = to;
		let source = this.state.products.find(x => x.key == parseInt(from));
		let target = this.state.products.find(x => x.key == parseInt(to));
		if (source == null || target == null) return;
		if (this.firstTimeSource == null) this.firstTimeSource = source;
		this.onMoveLogic(source, target, hideSource);
	}

	onMoveLogic(source, target, hideSource = null) {
		//CAREFUL, For maximum performance we must maintain the array's order, but change sort
		let newProductsSort = this.getSortProducts(source, target);
		this.setState({ products: newProductsSort }, () => {
			// Hide/show source products
			if (hideSource === true) {
				Common.setStyleToGridItem(
					newProductsSort[source.key],
					"opacity",
					0
				);
				this.hiddenElement = newProductsSort[source.key];
			} else if (hideSource === false) {
				Common.setStyleToGridItem(
					newProductsSort[source.key],
					"opacity",
					1
				);
				this.hiddenElement = null;
			}
		});

		clearTimeout(this.setTimeout);
		this.setTimeout = setTimeout(() => {
			this.from = -1;
			this.to = -1;
		}, 150);
	}

	getSortProducts(source, target, products = null) {
		if (products == null) products = this.state.products;
		let newProductsSort = products.map(item => {
			//Decrement sorts between positions when target is greater
			if (item.key === source.key) {
				return {
					...item,
					sort: target.sort
				};
			} else if (
				target.sort > source.sort &&
				(item.sort <= target.sort && item.sort > source.sort)
			) {
				return {
					...item,
					sort: item.sort - 1
				};
				//Increment sorts between positions when source is greater
			} else if (item.sort >= target.sort && item.sort < source.sort) {
				return {
					...item,
					sort: item.sort + 1
				};
			}
			return item;
		});

		return newProductsSort;
	}

	undoFirstTimeSource = () => {
		if (this.firstTimeSource != null) {
			let target = this.state.products.find(
				x => x.sort == this.firstTimeSource.sort
			);
			this.onMove(this.firstTimeSource.key, target.key, false);
			this.firstTimeSource = null;
		}
	};

	clearHiddenElement() {
		if (this.hiddenElement == null) return;
		Common.setStyleToGridItem(this.hiddenElement, "opacity", 1);
		this.hiddenElement = null;
		this.firstTimeSource = null;
	}

	onDragEnd(e, item) {
		if (e != null) this.firstTimeSource = null;
	}

	getBottomBarStyle() {
		let bottomBarStyle = styles.bottomBar;
		if (this.state.selectedItems.length > 0)
			bottomBarStyle = {
				...styles.bottomBar,
				...styles.bottomBarSelectedItemMode
			};
		return bottomBarStyle;
	}

	render() {
		if (this.state.noResults)
			return (
				<div style={styles.noResults}>
					<SentimentDissatisfied
						classes={{ root: css(classes.noResultsIcon) }}
					/>{" "}
					No Results
				</div>
			);
		return (
			this.state.open && (
				<div style={styles.root} id="ClientSite">
					{this.renderGrid()}
					<BottomBar
						clearSelectedItems={this.clearSelectedItems}
						setProducts={this.setProducts}
						selectedItems={this.state.selectedItems}
						changePage={this.changePage}
						maxPage={this.state.maxPage}
						pageLoading={this.state.pageLoading}
						products={this.state.products}
						categoryId={this.props.categoryId}
						categoryUrl={this.props.categoryUrl}
						categoryType={this.props.categoryType}
						style={this.getBottomBarStyle()}
						productsPerPage={this.productsPerPage}
						flatItems={this.state.flatItems}
						currentPage={this.state.currentPage}
					/>
				</div>
			)
		);
	}

	getGridLayoutTop() {
		const gridBoxInner = document.getElementById("GridBoxInner");
		if (gridBoxInner == null) return;
		const layoutTop = parseFloat(
			window
				.getComputedStyle(gridBoxInner, null)
				.getPropertyValue("padding-top")
				.slice(0, -2)
		);

		return layoutTop;
	}

	createFlatItemsPage() {
		WebWorkers.execute("CreateFlatItemsPage", [
			this.state.gridLayoutWidth,
			this.getGridLayoutTop(),
			this.state.itemWidth,
			this.state.itemHeight,
			-1,
			this.state.itemsPerRow,
			this.state.gridZoomNumber,
			this.productsPerPage,
			this.totalPages
		]);
	}

	createFlatItemsPageDone(res) {
		const flatItemsPages = res.map((pageTop, i) => {
			const pageNumber = i + 1;
			this.flatItemsPagesNumbers[i] = pageTop;
			return (
				<div
					key={"page_header" + pageNumber}
					style={{
						...styles.flatItemsPage,
						...{ top: pageTop + "px" }
					}}
				>
					<span style={styles.flatItemsPageText}>
						PAGE {pageNumber}
					</span>
				</div>
			);
		});

		this.setState({ flatItemsPages: flatItemsPages });
	}

	shouldCreateFlatItemsPage(prevState) {
		return (
			this.state.flatItems &&
			this.state.gridLayoutWidth > 0 &&
			(prevState.flatItems != this.state.flatItems ||
				prevState.gridZoomNumber != this.state.gridZoomNumber ||
				prevState.itemsPerRow != this.state.itemsPerRow ||
				prevState.gridLayoutWidth != this.state.gridLayoutWidth ||
				(prevState.gridForceResize == true &&
					this.state.gridForceResize == false))
		);
	}

	shouldClearFlatItemsPage() {
		return (
			this.state.flatItems === false &&
			this.state.flatItemsPages != null &&
			this.state.flatItemsPages.length > 0
		);
	}

	shouldUpdateCurrentPage() {
		return (
			this.state.flatItems == true &&
			this.flatItemsScrollToInProgress == false
		);
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.itemsPerRow != this.state.itemsPerRow ||
			prevState.sliderZoomValue != this.state.sliderZoomValue
		) {
			this.onResize();
		}

		if (this.shouldCreateFlatItemsPage(prevState))
			this.createFlatItemsPage();

		if (this.shouldClearFlatItemsPage())
			this.setState({ flatItemsPages: [] });
	}
}

export default ClientSite;
